import React, { useEffect, useState } from 'react';
import { Card, PageHeader, Button } from '../../components/shared/ui';
import { adminAPI } from '../../utils/api';

const SystemHealth = () => {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    adminAPI.getSystemHealth().then(r => setHealth(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);

  const fmt = (s) => { const h = Math.floor(s/3600), m = Math.floor((s%3600)/60); return h>0 ? `${h}s ${m}dk` : `${m}dk`; };

  return (
    <>
      <PageHeader
        title="Sistem Sağlığı"
        description="Servislerin canlı durumu (15sn'de bir yenilenir)"
        actions={<Button variant="secondary" onClick={load}>↻ Yenile</Button>}
      />
      {loading && !health ? (
        <p className="text-ink-500">Kontrol ediliyor...</p>
      ) : !health ? (
        <p className="text-red-600">Sistem bilgisi alınamadı</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl">
          {[
            { label:'Veritabanı',       value: health.database === 'ok' ? 'Çalışıyor' : 'HATA', ok: health.database === 'ok' },
            { label:'Backend Uptime',   value: fmt(health.uptime_seconds), ok: true },
            { label:'Bellek Kullanımı', value: `${health.memory_mb} MB`, ok: health.memory_mb < 512 },
            { label:'Node.js',          value: health.node_version, ok: true },
          ].map(item => (
            <Card key={item.label} className={!item.ok ? 'border-red-200' : ''}>
              <div className="text-sm text-ink-500 mb-1">{item.label}</div>
              <div className={`text-xl font-bold ${item.ok ? 'text-ink-900' : 'text-red-600'}`}>{item.value}</div>
              <div className={`mt-2 text-xs font-semibold ${item.ok ? 'text-emerald-600' : 'text-red-600'}`}>
                {item.ok ? '● Sağlıklı' : '● Hata'}
              </div>
            </Card>
          ))}
          <Card className="sm:col-span-2">
            <div className="text-sm text-ink-500 mb-1">Son Kontrol</div>
            <div className="text-base text-ink-900">{new Date(health.timestamp).toLocaleString('tr-TR')}</div>
            <div className="text-xs text-ink-400 mt-1">Otomatik yenileme: 15 saniyede bir</div>
          </Card>
        </div>
      )}
    </>
  );
};

export default SystemHealth;
